export const fieldStructure = Object.freeze({
  kind: 'field',
  item_id: null,
  name: "",
  type: "",
  logic: {},
  errors: {},
  hasErrors: false,
  options: {
    required: false,
    fieldTypeCfg: { data: [] }, //select/checkbox: [{ name, allowComment }]
    alarms: false,
  },
  show_if: [],               // [{ field: '<item_id>', op: '==', value: true }]
  show_logic: 'all',         // 'all' (AND) | 'any' (OR)
});

// Solo-UI para secciones
export const sectionStructure = Object.freeze({
  kind: 'section',
  section_id: null,
  name: "",
  collapsed: false,
  children: [],
});

export const fieldTypes = [
  {
    name: 'custom_forms.types.inputText',
    type: 'text',
    data_type: 'text',
    icon: 'TypeIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.select',
    type: 'select',
    data_type: 'select',
    icon: 'ListIcon',
    config: {},
  },
  {
    name: 'custom_forms.types.checkbox',
    type: 'checkbox',
    data_type: 'checkbox',
    icon: 'ListIcon',
    config: {},
  },
  // {
  //   name: 'custom_forms.types.inputGroup',
  //   type: 'inputGroup',
  //   data_type: 'inputGroup',
  //   icon: 'TypeIcon',
  //   config: {},
  // },
  {
    name: 'custom_forms.types.text_answer',
    type: 'text_answer',
    data_type: 'textarea',
    icon: 'MessageSquareIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.files_section',
    type: 'files_section',
    data_type: 'component',   // buider renders a FileUploadWithPreview
    icon: 'FileIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.commands',
    type: 'commands',
    data_type: 'commands',
    icon: 'TargetIcon',
    config: {},
  },
  {
    name: 'custom_forms.types.users',
    type: 'users',
    data_type: 'users',
    icon: 'UserIcon',
    config: null,
  },
  {
    name: 'custom_forms.types.rh_users',
    type: 'rhUsers',
    data_type: 'rhUsers',
    icon: 'UserIcon',
    config: null,
  },
  {
    name: 'custom_forms.types.facilities',
    type: 'facilities',
    data_type: 'facilities',
    icon: 'MapPinIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.placeholder',
    type: 'placeholder',
    data_type: 'text',
    icon: 'HashIcon',
    config: {},
  },
  {
    name: 'custom_forms.types.date',
    type: 'date',
    data_type: 'date',
    icon: 'CalendarIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.time',
    type: 'time',
    data_type: 'time',
    icon: 'ClockIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.distribution_lists',
    type: 'mailList',
    data_type: 'mailList',
    icon: 'AtSignIcon',
    config: false,
  },
  {
    name: 'custom_forms.types.recipient',
    type: 'recipient',
    data_type: 'recipient',
    icon: 'InboxIcon',
    config: false,
  },
  // {
  //   name: 'custom_forms.types.email',
  //   type: 'mail',
  //   data_type: 'mail',
  //   icon: 'MailIcon',
  //   config: true,
  // },
  {
    name: 'custom_forms.types.user_list',
    type: 'userList',
    data_type: 'userList',
    icon: 'UsersIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.keyword',
    type: 'keyword',
    data_type: 'keyword',
    icon: 'KeyIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.folio',
    type: 'folio',
    data_type: 'folio',
    icon: 'FileTextIcon',
    config: true,
  },
  {
    name: 'custom_forms.types.region',
    type: 'region',
    data_type: 'region',
    icon: 'MapIcon',
    config: false,
  },
  {
    name: 'custom_forms.types.timestamp',
    type: 'timestamp',
    data_type: 'timestamp',
    icon: 'CompassIcon',
    config: false,
  },
  {
    name: 'custom_forms.types.device_doc',
    type: 'deviceDoc',
    data_type: 'deviceDoc',
    icon: 'BookIcon',
    config: false,
  },
  {
    name: 'custom_forms.types.supplier',
    type: 'supplier',
    data_type: 'supplier',
    icon: 'UserPlusIcon',
    config: false,
  },
  {
    name: 'custom_forms.types.technicians',
    type: 'technicians',
    data_type: 'technicians',
    icon: 'ToolIcon',
    config: true,
  },
];
